import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import userManager from './userManager';

/**
 * A higher-order component that restricts access to authenticated
 * (and optionally authorized) users based on roles.
 */
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        async function checkUser() {
            try {
                const user = await userManager.getUser();
                if (!user) {
                    
                    // If no user is found, initiate login
                    await userManager.signinRedirect({ state: { from: location } });
                    return;
                }

                // Check the user's CUAR attribute to determine roles
                const cuar_value = user.profile.params?.CUAR;


                // If CUAR is missing, remove user and re-login
                if (!cuar_value) {
                    await userManager.removeUser();
                    await userManager.signinRedirect({ state: { from: location } });
                    return;
                }

                // Check if the user has at least one of the allowed roles

                const isEmployeeORDistributor =  cuar_value.includes('employee') || cuar_value.includes('distributor');
                if (!isEmployeeORDistributor) {
                    alert("You are registered but do not have an authorized role. This Service is for employees and distributors only!");
                    await userManager.signoutRedirect({
                        id_token_hint: user.id_token
                    });
                    return;
                }

                // If all checks pass, user is authorized
                setAuthorized(true);
            } catch (error) {
                // If any error occurs, log out
                console.error("ProtectedRoute error:", error);
                window.location.href = "https://copadata.onelogin.com/oidc/2/logout";
            } finally {
                setLoading(false);
            }
        }
        checkUser();
    }, [location, allowedRoles]);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <CircularProgress />
            </div>
        );
    }

    return authorized ? children : null;
};

export default ProtectedRoute;
